import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { browserLanguage, loadLanguage } from '../i18n/index.ts';
import { useSettings } from '../records/queries.ts';

/** The User's language from Settings, kept across devices; the browser's until they pick one. */
export function useLanguageFromSettings(): void {
  const { i18n } = useTranslation();
  const settings = useSettings();
  const language = settings.data?.language;
  useEffect(() => {
    if (settings.data === undefined) return;
    const next = language ?? browserLanguage();
    if (i18n.language !== next) void loadLanguage(i18n, next);
    document.documentElement.lang = next;
  }, [language, settings.data, i18n]);
}
